import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';



import { GET, queryFilterByItem, errorCatch, JSX } from 'fennec-ui'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { Option } = Select;


function SelectGroup({ value, onChange, options }) {
    return (
        <Input.Group compact style={{ display: "flex" }}>
            <Select
                onChange={onChange}
                value={value}

                style={{ flex: "auto" }}
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                    return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
                filterSort={(optionA, optionB) =>
                    optionA?.label?.toLowerCase().localeCompare(optionB?.label?.toLowerCase())
                }
            >
                {options}
            </Select>
            {/* <Button style={{ padding: "4px 8px" }} onClick={() => { }}>
                <EllipsisOutlined style={{ paddingTop: "7px", fontSize: '16px' }} />
            </Button> */}
            {/* <Button style={{ padding: "4px 8px" }} onClick={()=>{}}>
                        <PlusOutlined style={{ paddingTop: "3px", fontSize: '16px' }} />
                    </Button> */}
        </Input.Group>
    );
}

export default function NovieYacheikiVKomissiyah(props) {
    const { auth, object, form, sourceKey, queryFilterContext, soruceID, parentObject } = props;
    const [data, setData] = useState([]);
    useEffect(() => {
        form.resetFields();

        let postfix = "";
        if (sourceKey === "admin") {
            postfix = `/${soruceID}`
        }

        GET(auth, "/api/komissiipartneram/list/" + sourceKey + postfix + "?detail=model&w-notActive=false&" + (soruceID ? `w-eqornu-meropriyatie.ID=${soruceID}&` : "") + ((queryFilterContext) ? queryFilterByItem(queryFilterContext) : ""),
            ({ data }) => {
                setData(data);
            },
            (err) => errorCatch(err));
    }, []);
    const komissiyaPartneramOptions = data.map((i) => {
        let desc = "";
        if (i?.organizatorFederatsiya) {
            desc = "Федерация"
        } else if (i?.organizatorRegionalnoeOtdelenie) {
            desc = "" + i?.organizatorRegionalnoeOtdelenie?.nazvanie
        } else if (i?.organizatorShkola) {
            desc = "" + i?.organizatorShkola?.nazvanieShkoliTantsev
        } else if (i?.organizatorMeropriyatiya) {
            desc = "" + i?.organizatorMeropriyatiya?.nazvanie
        }

        if (i?.meropriyatie) {
            desc += ", " + `${i?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(i?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(i?.meropriyatie?.mestoProvedeniya) ? "(" + i?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
        }
        return (<Option key={i.ID} value={i.ID} label={i.sutKomissii}>
            <div>
                <div>{i.sutKomissii}</div>
                {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>{desc}</div>}
            </div>
        </Option>)
    });

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <div style={{ paddingBottom: "10px" }}>
                    {parentObject?.nazvanie &&
                        <div style={{ display: "flex", gap: "5px" }}>
                            <div>
                                <span style={{ fontWeight: "300" }}>Позиция: </span>
                            </div>
                            <div>
                                <div>
                                    <span>{parentObject?.nazvanie}</span>
                                </div>
                                {parentObject?.meropriyatie && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(parentObject?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(parentObject?.meropriyatie?.mestoProvedeniya) ? "(" + parentObject?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}
                                </div>}
                                {parentObject?.organizatorFederatsiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>Федерация</span>
                                </div>}
                                {parentObject?.organizatorRegionalnoeOtdelenieID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.organizatorRegionalnoeOtdelenie?.nazvanie}</span>
                                </div>}
                                {parentObject?.organizatorShkolaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.organizatorShkola?.nazvanieShkoliTantsev}</span>
                                </div>}
                                {parentObject?.organizatorMeropriyatiyaID && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>
                                    <span>{parentObject?.organizatorMeropriyatiya?.nazvanie}</span>
                                </div>}
                            </div>
                        </div>
                    }
                </div>
                <Form.Item label="Комиссия"
                    name="komissiyaPartneramID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите комиссию!' }]}
                >
                    <SelectGroup
                        options={komissiyaPartneramOptions}
                    />
                </Form.Item>
            </Form>
        </>
    );
}
